import React from 'react';

const PlusV2 = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement("path", { d: "M8.17057 3.33337V12.6667Z", fill: "#061619" }),
  /* @__PURE__ */ React.createElement("path", { d: "M3.50391 8.00004H12.8372Z", fill: "#061619" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.17057 3.33337V12.6667M3.50391 8.00004H12.8372",
      stroke: "#061619",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

export { PlusV2 };
//# sourceMappingURL=PlusV2.js.map
